const getBarcodeContent = (barcode_content, user) => {
  switch (barcode_content) {
    case 1:
      return user?.registration_no;
    case 2:
      return user?.reg_prefix + user?.registration_no;

    case 3:
      return user?.unique_id;

    default:
      return user?.registration_no;
  }
};
export default getBarcodeContent;
